import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Bars3Icon, XMarkIcon, ChevronDownIcon, PhoneIcon } from '@heroicons/react/24/outline';
import { contactConfig } from '../config/contactConfig';

const services = [
  { name: 'Otomatik Kepenk Servisi', href: '/kepenk-servisi', description: 'Bakım ve teknik kontrol' },
  { name: 'Kepenk Tamiri', href: '/kepenk-tamiri', description: 'Motor, ray, kart ve kumanda' },
  { name: 'Sıfır Kepenk', href: '/sifir-kepenk', description: 'Ölçü, sistem seçimi ve montaj' },
  { name: 'Kepenk Parçaları', href: '/kepenk-parcalari', description: 'Motor, kart, kumanda ve güç kaynağı' },
  { name: 'Kepenk Fiyatları', href: '/kepenk-fiyatlari', description: 'Başlangıç fiyatları ve hesaplama' }
];

const navigation = [
  { name: 'Hakkımızda', href: '/hakkimizda' },
  { name: 'Hizmetlerimiz', type: 'dropdown' },
  { name: 'Bilgi Merkezi', href: '/bilgi-merkezi' },
  { name: 'İletişim', href: '/iletisim' }
];

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="fixed inset-x-0 top-0 z-50 h-20 border-b border-white/15 bg-[#111817] lg:h-24" role="banner">
      <div className="container mx-auto h-full px-4">
        <nav className="flex h-full items-center justify-between" aria-label="Ana menü">
          <Link to="/" className="flex h-full items-center" aria-label="Olgun Kepenk ana sayfa">
            <img src="/assets/img/olgun-kepenk-logo.svg" alt="" width="210" height="64" className="h-16 w-auto lg:h-20" />
          </Link>

          <div className="hidden items-center gap-1 lg:flex">
            {navigation.map((item) => (
              item.type === 'dropdown' ? (
                <div key={item.name} className="group relative">
                  <button
                    type="button"
                    className="flex items-center gap-1 px-3 py-3 text-xs font-semibold uppercase tracking-[0.12em] text-white/80 hover:text-[#d8ba86]"
                    aria-haspopup="true"
                  >
                    {item.name}
                    <ChevronDownIcon className="h-4 w-4" aria-hidden="true" />
                  </button>
                  <div className="invisible absolute left-0 top-full w-80 pt-2 opacity-0 transition group-hover:visible group-hover:opacity-100 group-focus-within:visible group-focus-within:opacity-100">
                    <div className="overflow-hidden rounded-2xl border border-[#d8d1c3] bg-[#fcfbf8] py-2 shadow-xl">
                      {services.map((service) => (
                        <Link
                          key={service.href}
                          to={service.href}
                          className="block px-5 py-3 hover:bg-gray-50"
                        >
                          <span className="block font-semibold text-[#14201e]">{service.name}</span>
                          <span className="mt-1 block text-sm text-gray-600">{service.description}</span>
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              ) : (
                <Link
                  key={item.href}
                  to={item.href}
                  className="px-3 py-3 text-xs font-semibold uppercase tracking-[0.12em] text-white/80 hover:text-[#d8ba86]"
                >
                  {item.name}
                </Link>
              )
            ))}

            <a
              href={`tel:${contactConfig.phone}`}
              className="ml-3 inline-flex items-center gap-2 rounded-full border border-[#d8ba86] px-5 py-3 text-sm font-semibold text-[#d8ba86] transition-colors hover:bg-[#d8ba86] hover:text-[#111817]"
              aria-label={`Olgun Kepenk telefon: ${contactConfig.phoneDisplay}`}
            >
              <PhoneIcon className="h-5 w-5" aria-hidden="true" />
              {contactConfig.phoneDisplay}
            </a>
          </div>

          <button
            type="button"
            onClick={() => setIsOpen((open) => !open)}
            className="rounded-xl p-3 text-white hover:bg-white/10 lg:hidden"
            aria-expanded={isOpen}
            aria-controls="mobile-navigation"
            aria-label={isOpen ? 'Menüyü kapat' : 'Menüyü aç'}
          >
            {isOpen ? <XMarkIcon className="h-7 w-7" /> : <Bars3Icon className="h-7 w-7" />}
          </button>
        </nav>
      </div>

      {isOpen && (
        <nav id="mobile-navigation" className="border-t border-white/10 bg-[#111817] px-4 pb-5 lg:hidden" aria-label="Mobil menü">
          <div className="container mx-auto max-h-[calc(100vh-5rem)] overflow-y-auto py-3">
            {navigation.filter((item) => item.href).map((item) => (
              <Link
                key={item.href}
                to={item.href}
                onClick={() => setIsOpen(false)}
                className="block border-b border-white/10 px-3 py-3 font-semibold text-white"
              >
                {item.name}
              </Link>
            ))}
            <p className="px-3 pb-2 pt-4 text-sm font-bold uppercase text-white/70">Hizmetler</p>
            {services.map((service) => (
              <Link
                key={service.href}
                to={service.href}
                onClick={() => setIsOpen(false)}
                className="block px-3 py-2 text-white hover:bg-white/10"
              >
                {service.name}
              </Link>
            ))}
            <a
              href={`tel:${contactConfig.phone}`}
              onClick={() => setIsOpen(false)}
              className="mt-4 flex items-center justify-center gap-2 rounded-xl bg-[#d8ba86] px-4 py-3 font-bold text-[#111817]"
            >
              <PhoneIcon className="h-5 w-5" aria-hidden="true" />
              {contactConfig.phoneDisplay}
            </a>
          </div>
        </nav>
      )}
    </header>
  );
};

export default Header;
